import { FieldMessage } from 'braid-design-system';
import React from 'react';

import type {
  CreditCardFormValidationError,
  CreditCardFormValidationErrors,
} from '../../../../usecases/CreditCard/creditcardTypes';

interface ValidationMesasgeProp {
  errors: CreditCardFormValidationErrors;
  field: CreditCardFormValidationError;
}

const ValidationMesasge = ({ errors, field }: ValidationMesasgeProp) => {
  const msg = errors[field];

  if (msg && msg.length > 0) {
    return <FieldMessage id={`msg-${field}`} message={msg} tone="critical" />;
  }

  return <></>;
};

export default ValidationMesasge;
